import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/services/common.service';

import { Router } from '@angular/router';

import { NewauditComponent } from '../newaudit/newaudit.component';
import {  FormGroup,FormBuilder, Validators} from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
declare const copyToClipboard: any;

export interface VAEventInfo {
  Id: number;
  EventType: string;
  SourceAgent: string;
  MessageType: string;
  DXMessageType: string;
  Status: string;
  Deployment: string;
  ModifierID: string;
}

@Component({
  selector: 'app-eventinfo',
  templateUrl: './eventinfo.component.html',
  styleUrls: ['./eventinfo.component.scss']
})
export class EventinfoComponent {

  EventInfoFilterForm: FormGroup;
  eventInfoForm: FormGroup;
  reactiveFormstatustype: FormGroup;
 
  public reactiveFormdeployment: FormGroup;
  reactiveFormmessagetype: FormGroup;
  selectedCardId: number | null = null; 
  dxMessageTypes: any[] = [];
  dxMessageTypeIds: string[] = []; 
  dxMessageTypeValues: string[] = []; 
  selectedDxMessageType: string = ''; 
  selectedMessageType: string = ''; 

  deploymentItemsList = [];
  keywordsearch = "displayname";
  isLoadingagent: boolean = false;
  notfounddata: boolean;
  isLoadingpa: boolean;
  selectedAgentguid: string='';
  selectedAgentName: any;
  agenttype = 'Select';
  agenttypelist: any = [];

  statusvalue = '';
  agentmodevalue = 'Select';
  AgentDetailsList: any[];
  agentmodalheight: Number;
  cardHeight: Number = window.innerHeight - 190;
  minDate = new Date(1900, 0, 1);
  maxDate = new Date();
  AgentConfigList: any[];
  formatType: string = "text/plain";
  defaultFormatType:string='text/plain';
  editorOptions = {
    theme: 'vs', language: this.formatType, wordWrap: 'on',scrollBeyondLastLine: false
};
  screeHeightforinput = window.innerHeight - 379;
  configjson: any = "";
  configid: any = "";
  AgentConfigListBackUp: any[];
  filterpipelinelist = <any>[];
  filterpipelinebackuplist = <any>[];
  isLoadingFilteredValue: boolean;
  reactiveFormPipelineFilter: FormGroup;
  configguids: string = '';
  configagentid: string = '';
  configpipelinedisplayname: string = '';
  configentitydisplayname: string = '';
  isselectedpipeline: boolean = false;
  configagentapikey: string = "";
  isLoadingroutes: boolean;
  RouteNameList: any[];
  selectedrouteId: any;
  selectedrouteDisplayName: any;
  selectedrouteuniqueid: any;
  configstatus: any;
  editConfigLockbtn: any;
  isConfigKeysSelected: boolean = false;
  isConfigPopupOpened: boolean = false;
  deploymentSelected: string = '';
  filteredMessageTypeIds: string[] = [];
  eventType:string = '';
  selectedId:number = 0;
  vaEventInfoList: any[] = []; 
EventTypeList = <any>[];
 keywordsearchEventType = "lookupid";
 isLoadingEventType: boolean;
 notfounddata1: boolean;


  constructor(private _formBuilder: FormBuilder,private service: CommonService, private _fb: FormBuilder, private ngxUiLoaderService: NgxUiLoaderService, private toastr: ToastrService, private modalService: NgbModal, private activeModal: NgbActiveModal, private router: Router, private fb: FormBuilder
    ,public dialog: MatDialog
  ) {
   
    this.reactiveFormstatustype = this.fb.group({ statusname: '' });
    this.reactiveFormPipelineFilter = _fb.group({ filterpipeline: '' });
   
    this.agenttypelist = this.agenttypeAlllist;
    this.reactiveFormdeployment = this._formBuilder.group({ deploymentname: ['', Validators.required] });
    this.reactiveFormmessagetype = this.fb.group({
      dxmessagetype: [''], 
      messagetype: [''] 
    });

    this.eventInfoForm = this.fb.group({
      eventType: ['', Validators.required],
      deployment: ['', Validators.required],
      status: ['', Validators.required],
      dxMessageType: ['', Validators.required],
      messageType: ['', Validators.required]
    });

    this.EventInfoFilterForm = this.fb.group({
      eventType: [''],
      deployment: [''],
      status: [''],
      dxMessageType: [''],
      messageType: ['']
    });
  }

  registerMonacoCustomTheme() {
    monaco.editor.defineTheme("myCustomTheme", {
      base: "vs", // can also be vs or hc-black
      inherit: true, // can also be false to completely replace the builtin rules
      rules: [
        {
          token: "comment",
          foreground: "ffa500",
          fontStyle: "italic underline"
        }, {
          token: "comment.js",
          foreground: "008800",
          fontStyle: "bold"
        }, {
          token: "comment.css",
          foreground: "0000ff"
        }, // will inherit fontStyle from `comment` above
      ],
      colors: {}
    });
  }
  pagerolepermisions: any = [];
  isflasgSize: Subscription;


  async ngOnInit() {
    this.getEventType();
    this.getDeployments();
        this.reactiveFormdeployment.patchValue({ "deploymentname": this.deploymentSelected });
    
    const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'EventInfo').MenuId;
    const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
    actionitems.forEach(element => {
      this.pagerolepermisions[element.MenuName] = true;
    });
    
    this.getDXMessageTypes(); 
  }
 

  
  resetPage(resetEventInfoList: boolean = true,resetSelectedCard: boolean = true): void {
   
this.selectedEventtype = "";
   // Reset unified filter form
    this.EventInfoFilterForm.reset({
      eventType: '',
      deployment: '',
      status: '',
      dxMessageType: '',
      messageType: ''
    });

    // Reset status value and form controls
  this.statusvalue = '';
 
  

    // Reset eventInfoForm
  this.eventInfoForm.reset({
    eventType: '',
    deployment: '',
    status: '', 
    dxMessageType: '',
    messageType: ''
  });

    // Reset variables
    this.selectedAgentguid = '';
    this.selectedAgentName = '';
    this.selectedrouteId = '';
    this.selectedrouteDisplayName = '';
    this.selectedrouteuniqueid = '';
    this.deploymentSelected = '';
    this.selectedDxMessageType = '';
    this.selectedMessageType = '';
    this.eventType = '';
    this.selectedId = 0;
   
    

   
    this.isselectedpipeline = false;
    this.isConfigKeysSelected = false;
    this.isConfigPopupOpened = false;

   
    if (resetEventInfoList) {
      this.vaEventInfoList = [];
    }
   
  if (resetSelectedCard) {
    this.selectedCardId = null;
  }

 
    this.ngxUiLoaderService.stop();
  }
  agentObj: any;
  agenttitle: any;

  

  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }
 
  openAuditPopUp(uniqueid: any, id: any, EventType: any) {

    if (uniqueid != '' && id != '') {
      const auditDataToModal = {
        id: uniqueid,
        title: EventType,
        context: "VAEventInfo",
        type: "ID",
        guid: id,
        userid: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      };

      const modalRef = this.modalService.open(NewauditComponent,
        { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
      modalRef.componentInstance.inputDataInModalComponent = auditDataToModal;
      modalRef.result.then(() => { });
    }

  }
 



 
  agenttypelistdropdown: any = [];
  agenttypeAlllist: any = [];
  isLoadingagenttypedl: boolean = false;
  


  keyword = "value";


  async selectstatusEvent(item) {
    this.statusvalue = item.name;
  }

  clearedstatus(item) {
    this.statusvalue = '';
  }

  

  public status = [
    {
      name: 'true',
      value:'Active'
    },
    {
      name: 'false',
      value:'Passive'
    }
  ];
 
  getstringRoute(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }

  validateNumberInput(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numbers (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  //Deployment selection
  selectdeploymentEvent(item: any) {
    this.deploymentSelected = item;
    this.getAgentByDeploymentAndDirection();

  }
   onFocuseddeployment(event) {
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  cleareddeployment(event) {
    this.deploymentSelected = '';
    this.selectedAgentguid = '';
    this.reactiveFormdeployment.reset();
    this.reactiveFormdeployment.patchValue({ "deploymentname": '' });
    this.reactiveFormdeployment.patchValue(this.deploymentItemsList);
  }

  getDeployments() {
    this.service.getDeployments("Deployments").subscribe(
      (data) => {
        if (data.length > 0) {
          this.deploymentItemsList = data;
        } else if (data.length === 0) {
          this.deploymentItemsList = [];
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  getDXMessageTypes(): void {
    const lookuptype = 'DXmessagetype'; // Define the lookup type

    // Call the service method
    this.service.getlookupInfo(lookuptype).subscribe({
      next: (response: any[]) => {
        if (response && Array.isArray(response)) {
          // Store the response
          this.dxMessageTypes = response;

          // Extract distinct lookupvalue and all lookupid
          this.dxMessageTypeValues = [...new Set(response.map(item => item.lookupvalue))]; // Ensure unique lookupvalue
          this.dxMessageTypeIds = response; // Keep the full response for filtering
        }
      },
      error: (error) => {
        console.error('Error fetching DX Message Types:', error);
      }
    });
  }

  onDxMessageTypeSelected(event: any): void {
    this.selectedDxMessageType = event; // Store the selected dxmessagetype

  this.filteredMessageTypeIds = this.dxMessageTypes
    .filter(item => item.lookupvalue === this.selectedDxMessageType)
    .map(item => item.lookupid);
  }

  onMessageTypeSelected(event: any): void {
    this.selectedMessageType = event; // Store the selected messagetype
     }

  clearedDxMessagetype(event: any): void {
    this.selectedDxMessageType = '';
    this.filteredMessageTypeIds = [];
    this.selectedMessageType = '';
  }

  clearedMessagetype(event: any): void {
    this.selectedMessageType = '';
  }

  getVAEventInfo(resetHighligh: Boolean=false): void {
    this.ngxUiLoaderService.start();
    this.vaEventInfoList= [];
    if(resetHighligh == true){this.selectedCardId = null;}
    if (this.EventInfoFilterForm.value.Eventtype == "") {
        this.selectedEventtype = "";
      } else if (typeof this.EventInfoFilterForm.value.Eventtype == "string") {
        this.selectedEventtype = this.EventInfoFilterForm.value.Eventtype;
      } else if (typeof this.EventInfoFilterForm.value.Eventtype == "object") {
        this.selectedEventtype = this.EventInfoFilterForm.value.Eventtype
          ? this.EventInfoFilterForm.value.Eventtype.lookupvalue
          : "";
      }
    const requestBody: VAEventInfo = {
      Id: this.selectedId,
      EventType: this.selectedEventtype,
      SourceAgent: this.selectedAgentguid,
      MessageType: this.selectedMessageType,
      DXMessageType: this.selectedDxMessageType,
      Status: this.statusvalue,
      Deployment: this.deploymentSelected,
      ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    };

    this.service.GetVAEventInfo(requestBody).subscribe({
      next: (response: any) => {
        
        if (response && response.status === 'success' && response.responsebody) {
          this.ngxUiLoaderService.stop();
          this.vaEventInfoList = response.responsebody; 

        } else {
          this.ngxUiLoaderService.stop();
          this.toastr.warning('No Result Found', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });

        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.toastr.error('Error occurred while fetching VA Event Info.', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });

      }
    });
  }

  getAgentByDeploymentAndDirection(): void {
    if (!this.deploymentSelected) {
      return;
    }

    const direction = 'Outbound';


    this.service.GetAgentByDirectionAndDeployment(direction,this.deploymentSelected, ).subscribe({
      next: (response: any[]) => {
        if (response && Array.isArray(response) && response.length > 0) {

          this.selectedAgentguid = response[0].id;
        } else {
          this.selectedAgentguid = '';
        }
      },
      error: () => {

        this.selectedAgentguid = '';
      }
    });
  }

  openAddOrEditEventInfo(eventInfo: any, modal: any): void {
    this.ngxUiLoaderService.start(); // Start the loader
   this.resetPage(false,false); 
   this.eventInfoForm.reset();
  
    if (eventInfo) {
      
      this.selectedCardId = eventInfo.Id;
      const status = eventInfo.Status === 'True' ? 'Active' : 'Passive';

        const matchedEventType = this.EventTypeList.find(
      (et: any) => et.lookupvalue === eventInfo.EventType
    );
      this.eventInfoForm.patchValue({
        eventType: matchedEventType ? matchedEventType.lookupid : '',
        deployment: eventInfo.Deployment,
        status: status,
        dxMessageType: eventInfo.DXMessageType,
        messageType: eventInfo.MessageType
      });
  
      this.eventType = matchedEventType ? matchedEventType.lookupid : '';
      this.selectedId = eventInfo.Id;
      this.selectedAgentguid = eventInfo.SourceAgent;
      this.statusvalue = status;
      this.deploymentSelected = eventInfo.Deployment;
      this.selectedMessageType = eventInfo.MessageType;
      this.selectedDxMessageType = eventInfo.DXMessageType;
  
      this.agentObj = JSON.parse(JSON.stringify(eventInfo)); // Clone the event info object
      this.agenttitle = "Edit Event Info";
    } else {
      this.selectedCardId = null;
      this.eventInfoForm.patchValue({
        eventType: '',
        deployment: '',
        status: '',
        dxMessageType: '',
        messageType: ''
      });
  
      this.selectedId = 0;
    this.selectedAgentguid = '';
    this.statusvalue = '';
    this.deploymentSelected = '';
    this.selectedMessageType = '';
    this.selectedDxMessageType = '';
  
      this.agentObj = {
        Id: 0,
        EventType: '',
        SourceAgent: '',
        MessageType: '',
        DXMessageType: '',
        Status: 'true',
        Deployment: '',
        ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
      };
      this.agenttitle = "Add Event Info";
    }
  
    // Open the modal
    setTimeout(() => {
    this.modalService.open(modal, {
      windowClass: eventInfo ? "eventinfo-modal-edit" : "eventinfo-modal-add",
      backdrop: 'static',
      keyboard: false
    }).result.then(
      (result) => {
      },
      (reason) => {
        this.resetPage(false,false);
      }
    )
    ,0});
  

    this.ngxUiLoaderService.stop(); 
  }

  saveEventInfo(modal: any): void {
    this.ngxUiLoaderService.start();
   

    if (this.eventInfoForm.invalid) {
      this.ngxUiLoaderService.stop();
      this.toastr.warning('Please fill in all mandatory fields.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }
    if (!this.selectedAgentguid) {
      this.ngxUiLoaderService.stop();
      this.toastr.warning("Unable to get sourceagent", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    else {
      // Normalize status value
  let statusValue = this.eventInfoForm.value.status;
  if (typeof statusValue === 'object' && statusValue !== null && statusValue.name !== undefined) {
    statusValue = statusValue.name;
  }
  else {
    statusValue = (statusValue && statusValue.toString().toLowerCase() === 'active') ? 'true' : 'false';
  }
      const eventInfo = {
        Id: this.selectedId,
        EventType: this.eventInfoForm.value.eventType.lookupvalue,
        SourceAgent: this.selectedAgentguid, 
        MessageType: this.eventInfoForm.value.messageType,
        DXMessageType: this.eventInfoForm.value.dxMessageType,
        Status: statusValue, 
        Deployment: this.eventInfoForm.value.deployment, 
        ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'] 
      };

      this.service.UpdateInsertVAEventInfo(eventInfo).subscribe({
        next: (response: any) => {
          if (response && response.status === 'success') {
           if (this.selectedId && this.selectedId > 0) {
          // Edit
          this.toastr.success('Event Info Updated Successfully!', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        } else {
          // Add
          this.toastr.success('Event Info Added Successfully!', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
            modal.close('Save click');
            this.resetPage(true,false); // Reset vaEventInfoList after saving
            this.getVAEventInfo(false); 
          } else {
            this.toastr.error('Record already exist', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
          this.ngxUiLoaderService.stop();
        },
        error: (error) => {
          this.ngxUiLoaderService.stop();
          this.toastr.error('Error occurred while saving Event Info.', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      });
    } 
  }

  async deleteEventInfo(eventId: number): Promise<void> {
    const message = `Are you sure you want to delete this item?`;
        const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "500px", data: dialogData, disableClose: true });
        const dialogResult = await dialogRef.afterClosed().toPromise();
        if (dialogResult === false) {
          return;
        }
    this.ngxUiLoaderService.start();
    const deleterequestbody: VAEventInfo = {
      Id: eventId,
      EventType: '',
      SourceAgent: '',
      MessageType: '',
      DXMessageType: '',
      Status: '',
      Deployment: '',
      ModifierID: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    };
      this.service.DeleteVAEventInfo(deleterequestbody).subscribe({
        next: (response: any) => {
          if (response && response.status === 'success') {
            this.ngxUiLoaderService.stop();
            this.toastr.success('Event Info deleted successfully!', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            this.resetPage(true); 
           
           this.getVAEventInfo(false);
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.error('Failed to delete Event Info.', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        },
        error: (error) => {
          this.ngxUiLoaderService.stop();
          this.toastr.error('Error occurred while deleting Event Info.', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
         
        }
      });
    }
//Eventype search
 selectedEventtype: string;
  selectedeventtype(item) {
    this.selectedEventtype = item.lookupvalue;
  }
    searchEventTypeCleared(event) {
    this.isLoadingEventType = false;
    // this.EventTypeList = [];
    this.notfounddata1 = false;
    this.selectedEventtype = "";
    this.EventInfoFilterForm.patchValue({
      Eventtype: "",
    });
  }
     getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

 getEventType() {
    this.service.getEventType().subscribe(
      (data) => {
        if (data.length > 0) {
          this.EventTypeList = this.getUniqueListBy(data, "lookupid");
         
        } else if (data.length === 0) {
          this.EventTypeList = [];
          //this.notfounddata7 = true;
        }
      },
      (error) => {
        this.toastr.error("Something went wrong", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }
}
